export const initDeviceInfo = async (): Promise<void> => {
  if (typeof window !== 'undefined') {
    const { setDeviceInfo } = await import('./setDeviceInfo')
    await setDeviceInfo()
  }
}
